import { axiosNodeInstance } from "../../../adapters/axiosInstance";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    CREATE_SALES_SAVE_FILTER,
    GET_SALES_SAVE_FILTER,
    DELETE_SALES_SAVE_FILTER,
    UPDATE_SALES_SAVE_FILTER,
    GET_SALES_SHARE_FILTER,
    CREATE_SALES_SHARE_FILTER,
    REMOVE_SALES_SHARE_FILTER,
    CREATE_SERVICES_SAVE_FILTER,
    GET_SERVICES_SAVE_FILTER,
    DELETE_SERVICES_SAVE_FILTER,
    UPDATE_SERVICES_SAVE_FILTER,
    GET_SERVICES_SHARE_FILTER,
    CREATE_SERVICES_SHARE_FILTER,
    REMOVE_SERVICES_SHARE_FILTER,
    CREATE_ESCALATIONS_SAVE_FILTER,
    GET_ESCALATIONS_SAVE_FILTER,
    DELETE_ESCALATIONS_SAVE_FILTER,
    UPDATE_ESCALATIONS_SAVE_FILTER,
    GET_ESCALATIONS_SHARE_FILTER,
    CREATE_ESCALATIONS_SHARE_FILTER,
    REMOVE_ESCALATIONS_SHARE_FILTER,
} from "./filterTypes";

/*
|---------------------------------------------
|   Sales Filter APIs
|---------------------------------------------
*/
export const createSalesSaveFilter = createAsyncThunk(CREATE_SALES_SAVE_FILTER, async (input) => {
    await axiosNodeInstance.post("estimate_quotes/create/save_filter", input);
    const response = await axiosNodeInstance.get("estimate_quotes/get/save_filter", {
        params: { userId: input.user_id, category: "sales" }
    });
    return response.data;
});

export const getSalesSaveFilter = createAsyncThunk(GET_SALES_SAVE_FILTER, async () => {
    const user = JSON.parse(localStorage.getItem("loggedData"));
    const response = await axiosNodeInstance.get("estimate_quotes/get/save_filter", {
        params: { userId: user.user_id, category: "sales" }
    });
    return response.data;
});

export const deleteSalesSaveFilter = createAsyncThunk(DELETE_SALES_SAVE_FILTER, async (input) => {
    await axiosNodeInstance.delete("estimate_quotes/delete/save_filter", { params: input });
    const user = JSON.parse(localStorage.getItem("loggedData"));
    const response = await axiosNodeInstance.get("estimate_quotes/get/save_filter", {
        params: { userId: user.user_id, category: "sales" }
    });
    return response.data;
});

export const updateSalesSaveFilter = createAsyncThunk(UPDATE_SALES_SAVE_FILTER, async (input) => {
    await axiosNodeInstance.post("estimate_quotes/update/save_filter", input);
    const user = JSON.parse(localStorage.getItem("loggedData"));
    const response = await axiosNodeInstance.get("estimate_quotes/get/save_filter", {
        params: { userId: user.user_id, category: "sales" }
    });
    return response.data;
});

export const getSalesShareFilter = createAsyncThunk(GET_SALES_SHARE_FILTER, async () => {
    const user = JSON.parse(localStorage.getItem("loggedData"));
    const response = await axiosNodeInstance.get("estimate_quotes/get/share_filter", {
        params: { userId: user.user_id, category: "sales" }
    });
    return response.data;
});

export const createSalesShareFilter = createAsyncThunk(CREATE_SALES_SHARE_FILTER, async (input) => {
    await axiosNodeInstance.post("estimate_quotes/post/share_filter", input);
    const user = JSON.parse(localStorage.getItem("loggedData"));
    const response = await axiosNodeInstance.get("estimate_quotes/get/share_filter", {
        params: { userId: user.user_id, category: "sales" }
    });
    return response.data;
});

export const removeSalesShareFilterUser = createAsyncThunk(REMOVE_SALES_SHARE_FILTER, async (input) => {
    await axiosNodeInstance.post("estimate_quotes/remove/share_filter", input);
    const user = JSON.parse(localStorage.getItem("loggedData"));
    const response = await axiosNodeInstance.get("estimate_quotes/get/share_filter", {
        params: { userId: user.user_id, category: "sales" }
    });
    return response.data;
});

/*
|---------------------------------------------
|   Services Filter APIs
|---------------------------------------------
*/
export const createServicesSaveFilter = createAsyncThunk(CREATE_SERVICES_SAVE_FILTER, async (input) => {
    await axiosNodeInstance.post("estimate_quotes/create/save_filter", input);
    const response = await axiosNodeInstance.get("estimate_quotes/get/save_filter", {
        params: { userId: input.user_id, category: "services" }
    });
    return response.data;
});

export const getServicesSaveFilter = createAsyncThunk(GET_SERVICES_SAVE_FILTER, async () => {
    const user = JSON.parse(localStorage.getItem("loggedData"));
    const response = await axiosNodeInstance.get("estimate_quotes/get/save_filter", {
        params: { userId: user.user_id, category: "services" }
    });
    return response.data;
});

export const deleteServicesSaveFilter = createAsyncThunk(DELETE_SERVICES_SAVE_FILTER, async (input) => {
    await axiosNodeInstance.delete("estimate_quotes/delete/save_filter", { params: input });
    const user = JSON.parse(localStorage.getItem("loggedData"));
    const response = await axiosNodeInstance.get("estimate_quotes/get/save_filter", {
        params: { userId: user.user_id, category: "services" }
    });
    return response.data;
});

export const updateServicesSaveFilter = createAsyncThunk(UPDATE_SERVICES_SAVE_FILTER, async (input) => {
    await axiosNodeInstance.post("estimate_quotes/update/save_filter", input);
    const user = JSON.parse(localStorage.getItem("loggedData"));
    const response = await axiosNodeInstance.get("estimate_quotes/get/save_filter", {
        params: { userId: user.user_id, category: "services" }
    });
    return response.data;
});

export const getServicesShareFilter = createAsyncThunk(GET_SERVICES_SHARE_FILTER, async () => {
    const user = JSON.parse(localStorage.getItem("loggedData"));
    const response = await axiosNodeInstance.get("estimate_quotes/get/share_filter", {
        params: { userId: user.user_id, category: "services" }
    });
    return response.data;
});

export const createServicesShareFilter = createAsyncThunk(CREATE_SERVICES_SHARE_FILTER, async (input) => {
    await axiosNodeInstance.post("estimate_quotes/post/share_filter", input);
    const user = JSON.parse(localStorage.getItem("loggedData"));
    const response = await axiosNodeInstance.get("estimate_quotes/get/share_filter", {
        params: { userId: user.user_id, category: "services" }
    });
    return response.data;
});

export const removeServicesShareFilterUser = createAsyncThunk(REMOVE_SERVICES_SHARE_FILTER, async (input) => {
    await axiosNodeInstance.post("estimate_quotes/remove/share_filter", input);
    const user = JSON.parse(localStorage.getItem("loggedData"));
    const response = await axiosNodeInstance.get("estimate_quotes/get/share_filter", {
        params: { userId: user.user_id, category: "services" }
    });
    return response.data;
});

/*
|---------------------------------------------
|   Escalations Filter APIs
|---------------------------------------------
*/
export const createEscalationsSaveFilter = createAsyncThunk(CREATE_ESCALATIONS_SAVE_FILTER, async (input) => {
    await axiosNodeInstance.post("estimate_quotes/create/save_filter", input);
    const response = await axiosNodeInstance.get("estimate_quotes/get/save_filter", {
        params: { userId: input.user_id, category: "escalations" }
    });
    return response.data;
});

export const getEscalationsSaveFilter = createAsyncThunk(GET_ESCALATIONS_SAVE_FILTER, async () => {
    const user = JSON.parse(localStorage.getItem("loggedData"));
    const response = await axiosNodeInstance.get("estimate_quotes/get/save_filter", {
        params: { userId: user.user_id, category: "escalations" }
    });
    return response.data;
});

export const deleteEscalationsSaveFilter = createAsyncThunk(DELETE_ESCALATIONS_SAVE_FILTER, async (input) => {
    await axiosNodeInstance.delete("estimate_quotes/delete/save_filter", { params: input });
    const user = JSON.parse(localStorage.getItem("loggedData"));
    const response = await axiosNodeInstance.get("estimate_quotes/get/save_filter", {
        params: { userId: user.user_id, category: "escalations" }
    });
    return response.data;
});

export const updateEscalationsSaveFilter = createAsyncThunk(UPDATE_ESCALATIONS_SAVE_FILTER, async (input) => {
    await axiosNodeInstance.post("estimate_quotes/update/save_filter", input);
    const user = JSON.parse(localStorage.getItem("loggedData"));
    const response = await axiosNodeInstance.get("estimate_quotes/get/save_filter", {
        params: { userId: user.user_id, category: "escalations" }
    });
    return response.data;
});

export const getEscalationsShareFilter = createAsyncThunk(GET_ESCALATIONS_SHARE_FILTER, async () => {
    const user = JSON.parse(localStorage.getItem("loggedData"));
    const response = await axiosNodeInstance.get("estimate_quotes/get/share_filter", {
        params: { userId: user.user_id, category: "escalations" }
    });
    return response.data;
});

export const createEscalationsShareFilter = createAsyncThunk(CREATE_ESCALATIONS_SHARE_FILTER, async (input) => {
    await axiosNodeInstance.post("estimate_quotes/post/share_filter", input);
    const user = JSON.parse(localStorage.getItem("loggedData"));
    const response = await axiosNodeInstance.get("estimate_quotes/get/share_filter", {
        params: { userId: user.user_id, category: "escalations" }
    });
    return response.data;
});

export const removeEscalationsShareFilterUser = createAsyncThunk(REMOVE_ESCALATIONS_SHARE_FILTER, async (input) => {
    await axiosNodeInstance.post("estimate_quotes/remove/share_filter", input);
    const user = JSON.parse(localStorage.getItem("loggedData"));
    const response = await axiosNodeInstance.get("estimate_quotes/get/share_filter", {
        params: { userId: user.user_id, category: "escalations" }
    });
    return response.data;
});